import { render, staticRenderFns } from "./ChapterTable.vue?vue&type=template&id=05417e62&"
import script from "./ChapterTable.vue?vue&type=script&lang=ts&"
export * from "./ChapterTable.vue?vue&type=script&lang=ts&"
import style0 from "./ChapterTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VExpandXTransition } from 'vuetify/lib/components/transitions';
import { VTreeview } from 'vuetify/lib/components/VTreeview';
installComponents(component, {VExpandXTransition,VTreeview})
